import { message } from "antd";
import { AUTH, LOGOUT } from "../constants/authContants";
import * as api from "../../api/index";

export const signin = (formData) => async (dispatch) => {
  try {
    const { data } = await api.signIn(formData);
    dispatch({ type: AUTH, data });
    if (data?.id) {
      message.success("Sign In successfully");
      window.location.reload(true);
    }
  } catch (error) {
    if (error) {
      console.log(error);
      message.error(error?.response?.data?.message);
    }
  }
};

export const signUp = (formData, history) => async (dispatch) => {
  try {
    const { data } = await api.signUp(formData);
    dispatch({ type: AUTH, data });
    if (data) {
      history("/account");
      message.success("Account created, please login");
    }
  } catch (error) {
    if (error) {
      console.log(error?.response?.data?.message);
      message.error(
        error?.response?.data?.message
          ? error?.response?.data?.message
          : "Network Error"
      );
    }
  }
};

export const logout = () => async (dispatch) => {
  try {
    dispatch({ type: LOGOUT });
  } catch (error) {
    if (error) {
      console.log(error?.response?.data?.message);
    }
  }
};
